import { Fragment } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { PushNotificationsPopup } from '@/components/PushNotificationsPopup';
import useAuth from '@/hooks/useAuth';
import ROUTER from '@/router/routes';

type Props = {
  element: JSX.Element;
  replace?: boolean;
};

const PrivateRoute = ({ element }: Props) => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? (
    <Fragment>
      {element}
      <PushNotificationsPopup />
    </Fragment>
  ) : (
    <Navigate replace state={{ from: location }} to={ROUTER.basePath} />
  );
};

export default PrivateRoute;
